import React from 'react'

const LoadingSpinner = () => {
    return (
        <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-[var(--primary-color)]"></div>
        </div>
    )
}

export default LoadingSpinner